import cleanedFilename from '~/util/cleanedFilename';

export default {
  EMAIL_SETTINGS: `${cleanedFilename(__filename)}-email-settings`,
  UNSUBSCRIBE_TEXT_INPUT: `${cleanedFilename(
    __filename,
  )}-unsubscribe-text-input`,
  ERROR_MESSAGE: `${cleanedFilename(__filename)}-error-message`,
};
